import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'loyaltic-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  customOptions: OwlOptions = {
    loop: true,
    center: true,
    autoplay: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      "<img src='https://assets.qnordicsgames.com/image/upload/q_auto/v1/NOSYNPRO25/prev.png'>",
        "<img src='https://assets.qnordicsgames.com/image/upload/q_auto/v1/NOSYNPRO25/next.png'>",
    ],
    responsive: {
      0: {
        items: 2,
        stagePadding: 50
      },
      400: {
        items: 2,
        stagePadding: 50
      },
      740: {
        items: 3
      },
      940: {
        items: 3
      },
      1200: {
        items: 3
      }
    },
    nav: true,
    
  }

  constructor() { }

  ngOnInit() {
  }

}
